export default "__VITE_ASSET__CK1_Da6i__"